import React, { useMemo } from 'react';
import { useMovieSearch } from '../hooks/useMovie';
import { usePageTitle } from '../hooks/usePageTitle';
import { toTitles, slugify } from '../lib/catalogue';
import { SeriesSpotlight } from '../components/series-spotlight';
import { SeriesView } from '../components/series-view';
import { SubscribeBand } from '../components/subscribe-band';

export default function SeriesPage() {
  usePageTitle(
    'Series · Kast',
    'Binge TV series and episodic stories streaming on Kast. Explore episodes, watch trailers, and stream.'
  );
  const { data: results = [], isLoading } = useMovieSearch('', undefined);

  const series = useMemo(() => {
    const list = Array.isArray(results) ? results : results?.data || [];
    return toTitles(list).filter((t) => t.isSeries);
  }, [results]);

  const featured = series.length > 0 ? series[0] : null;

  const genres = useMemo(() => {
    const counts = new Map();
    for (const item of series) {
      const name = item.category || 'Other';
      counts.set(name, (counts.get(name) || 0) + 1);
    }
    return [...counts.entries()].map(([name, count]) => ({
      id: slugify(name) || name,
      name,
      count,
    }));
  }, [series]);

  return (
    <div className="flex flex-col min-h-screen">
      {isLoading ? (
        <div className="w-full min-h-[65vh] sm:min-h-[72vh] lg:min-h-[78vh] bg-card/20 animate-pulse" />
      ) : (
        <SeriesSpotlight series={featured} />
      )}

      <SeriesView series={series} genres={genres} />

      <SubscribeBand />
    </div>
  );
}
